// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AuctionPurchase } from './auction-purchase';
import { Invoice } from './invoice';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class InvoiceLine extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get lineTotal() {
        return this.quantity * this.price;
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  auctionPurchaseId?: number;
  created!: Date;
  createdBy?: string;
  deleted?: Date;
  deletedBy?: string;
  description?: string;
  invoiceId!: number;
  isDonationQualified!: boolean;
  lineNumber!: number;
  partNumber?: string;
  price!: number;
  quantity!: number;
  auctionPurchase!: AuctionPurchase;
  invoice!: Invoice;
}

